import { IssueCard } from './IssueCard';
import type { Issue } from '@/types/reportApp';

interface IssueGroupProps {
  title: string;
  icon: React.ElementType;
  issues: Issue[];
  editingIssue: string | null;
  readOnly?: boolean;
  onEdit: (id: string) => void;
  onCancelEdit: () => void;
  onUpdate: (issueId: string, updates: Partial<Issue>) => void;
  onApprove: (issueId: string) => void;
  onMoveToPending: (issueId: string) => void;
  onDismiss: (issueId: string) => void;
}

export function IssueGroup({
  title,
  icon: Icon,
  issues,
  editingIssue,
  readOnly = false,
  onEdit,
  onCancelEdit,
  onUpdate,
  onApprove,
  onMoveToPending,
  onDismiss,
}: IssueGroupProps) {
  return (
    <div>
      <h3 className="text-sm font-semibold text-gray-600 mb-2 flex items-center gap-2">
        <Icon className="w-4 h-4" />
        {title} ({issues.length} {issues.length === 1 ? 'issue' : 'issues'})
      </h3>
      <div className="space-y-2">
        {issues.map(issue => (
          <IssueCard
            key={issue.id}
            issue={issue}
            isEditing={editingIssue === issue.id}
            readOnly={readOnly}
            onEdit={() => onEdit(issue.id)}
            onCancelEdit={onCancelEdit}
            onUpdate={onUpdate}
            onApprove={() => onApprove(issue.id)}
            onMoveToPending={() => onMoveToPending(issue.id)}
            onDismiss={() => onDismiss(issue.id)}
          />
        ))}
      </div>
    </div>
  );
}
